import { useTheme } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { useHistory } from 'react-router-dom';
import { Element } from 'react-scroll';

import { ButtonLink, LeftRightPositioning, Space, TruncatedText } from '@/components';
import { Transaction, WalletUIState } from '@/model/wallets/types';

import { TransactionAmount, TransactionIcon, TransactionTitle } from './components';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    minWidth: 0,
  },
  comment: {
    backgroundColor: theme.colors.light,
    borderRadius: '0px 16px 16px 16px',
    padding: '8px 16px',
  },
}));

export interface TransactionRowProps {
  'data-test'?: string;
  value: Transaction;
  style?: React.CSSProperties;
  basePath: string;
}

const TransactionRow: React.FC<TransactionRowProps> = ({ value, style, basePath, 'data-test': dataTest }) => {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();
  const Row = React.memo(({ style: extraStyle }: { style?: CSSProperties }) => (
    <Space
      style={{
        ...extraStyle,
        flexGrow: 1,
        minWidth: '62px',
        paddingTop: '12px',
        paddingBottom: '12px',
      }}
    >
      <TransactionIcon value={value} data-test={dataTest && `${dataTest}-icon`} />
      <Space
        direction="vertical"
        style={{
          flexGrow: 1,
          alignContent: 'flex-start',
          minWidth: 0,
        }}
      >
        <LeftRightPositioning
          style={{ alignItems: 'flex-start' }}
          leftClassName={classes.title}
          left={<TransactionTitle data-test={dataTest && `${dataTest}-title`} value={value} />}
          right={<TransactionAmount data-test={dataTest && `${dataTest}-amount`} value={value} />}
        />
        {value.comment && (
          <Space data-test={dataTest && `${dataTest}-comment`} className={clsx(classes.comment, 'ym-hide-content')}>
            <TruncatedText>{value.comment}</TruncatedText>
          </Space>
        )}
      </Space>
    </Space>
  ));
  return (
    <Element name={`tx-row-${value.transactionId}`}>
      <Space size={0} style={style} id={`tx-row-${value.transactionId}`}>
        <ButtonLink
          data-test={dataTest && `${dataTest}-txLink`}
          onClick={(): void => {
            history.push(`/${basePath}/${WalletUIState.TRANSACTION}/${value.transactionId}`);
          }}
          style={{
            width: '100%',
            position: 'unset',
            outline: 'none',
            color: 'initial',
            textAlign: 'initial',
            textDecoration: 'none !important',
          }}
        >
          <Row style={{ borderColor: theme.colors.accent }} />
        </ButtonLink>
      </Space>
    </Element>
  );
};

export default TransactionRow;
